import { SurveyQuestion } from "modules/NewClientSurvey/common/interface"
import { AnswerType } from "modules/NewClientSurvey/common/constants"
import { numberOfThemes } from "utils/infrastructure/wording-utils"

export const getInfo = (question: SurveyQuestion) => {
    const entries: string[] = []
    if (question.type === AnswerType.choices) {
        if (question.validations.min_count || question.validations.max_count) {
            entries.push("Выберите ")
        }
        if (question.validations.min_count) {
            entries.push(`от ${question.validations.min_count} `)
        }
        if (question.validations.max_count) {
            entries.push(`не более ${question.validations.max_count} `)
        }
        const count = question.validations.max_count ?? question.validations.min_count
        if (count !== undefined) {
            entries.push(numberOfThemes(count))
        }
    }
    return entries.join("")
}
